  <style>
  .no-bullets {
    list-style-type: none;
    padding-left: 0;
    margin: 0;
  }
  .form-label {
    word-break: break-word;
    white-space: normal;
  }
  .swal-success-toast {
    background-color: #28a745 !important; /* Bootstrap green */
    color: white !important;
  }

  .content-box h6 {
      color: rgba(199, 29, 34, 1);
      font-weight: 600;
  }


  /* Keep header cells from breaking or wrapping */
table th {
  white-space: nowrap;
  text-align: center;
}

/* Style for Name column */
td.name-cell {
  max-width: 120px; /* or whatever fits best */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
}
td.name-cell-3 {
  max-width: 180px; /* or whatever fits best */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
}
.for-header {
  text-align: left !important;
}
.my-red-button {
  background-color: #e53935 !important; /* red */
  color: white !important;
  border: none;
  box-shadow: none;
}

.my-red-button:hover {
  background-color: #c62828 !important;
}

/* Make Pending column wider on small screens */
@media (max-width: 768px) {
  .responsive-table td:nth-child(5) { /* 5th column = Pending */
    min-width: 300px; /* or adjust as needed */
  }

  /* Ensure the row content wraps nicely */
  .responsive-table td .row {
    flex-wrap: wrap;
  }

  .responsive-table td .col-md-5,
  .responsive-table td .col-md-4,
  .responsive-table td .col-md-3 {
    flex: 1 1 100%; /* stack columns on mobile */
    max-width: 100%;
  }

  /* File preview responsive */
  .responsive-table td img,
  .responsive-table td embed {
    width: 100% !important;
    height: auto !important;
  }
}

 .instruction-scroll {
    max-height: 300px; /* approx. 200 words height */
    overflow-y: auto;
    padding-right: 10px; /* avoid scrollbar overlapping text */
  }


</style>
  <template>
    <div>

                      <div  class="details-view-2" style="position: relative;">
                        <button @click="$emit('close')" style="position: absolute; top: 0; right: 0; border: none; background: none; font-size: 1.5rem; padding: 10px; cursor: pointer;">&times;</button>
                        <h5><br></h5>
                        <div class="row my-4">
                          
                        </div>
                        <hr />
                        <div class="row align-items-center">
                          <div class="col-lg-5">
                            <h5>Applicant(s) List</h5>
                          </div>
                          <div class="col-lg-7"  v-if="!isApplicantSlotPassedOrNot">
                            <div class="d-flex flex-wrap justify-content-end align-items-center gap-2" v-if="booking.is_cancelled === false && !anyApplicantRescheduled && !anyApplicantCancelled">
                              <button class="btn reschedule-btn me-3" v-if="!isApplicationsEmpty && booking.is_rescheduled === false"  @click="confirmReschedule(booking.id, booking.booking_no, booking.phone, booking.name, booking.email)">Re-Schedule</button>
                              <button class="btn cancel-btn me-3" v-if="!isApplicationsEmpty && booking.is_rescheduled === false" @click="confirmApplicationEntireCancel(booking.id, booking.booking_no, booking.phone, booking.name, booking.email)">Cancel</button>
                              <!-- This line will trigger the computed property -->
                              <button v-if="isApplicationsEmpty" @click="callEntireEditApiFunction()"  class="btn reschedule-btn me-3">+ Add Applicant (None Added Yet)</button>
                              <button v-if="isTotalApplicantNotMatchApplications && !isApplicationsEmpty" @click="callEditNewMemberApiFunction()"  class="btn reschedule-btn me-3">+ Add Missing Applicant</button>
                              <!-- @click="callEntireEditFormFunction(booking.id, booking.booking_no, booking.phone, booking.name, booking.email)" -->
                              <button v-if="!isSlotPassed(booking.slot) && !isApplicationsEmpty && !isTotalApplicantNotMatchApplications && booking.is_rescheduled === false && booking.is_cancelled === false && Number(booking.slot?.available_slot_count) > 0" @click="callToAdditionalMember(booking,booking.id, booking.booking_no, booking.phone, booking.name, booking.email)"  class="btn reschedule-btn me-3">+Add New Member</button>
                            </div>
                            <!-- If booking is booking_completely_rescheduled -->
                            <div class="d-flex justify-content-end align-items-center" v-else-if="booking.booking_completely_rescheduled === true">
                              <button class="btn btn-danger text-white me-3" disabled>
                                Rescheduled
                              </button>
                            </div>
                            <!-- If booking is cancelled -->
                            <div class="d-flex justify-content-end align-items-center" v-else-if="booking.is_cancelled === true">
                              <button class="btn btn-danger text-white me-3" disabled>
                                Cancelled
                              </button>
                            </div>
                          </div>

                          <div class="col-lg-7"  v-else-if="canAddApplicantToday">
                            <div class="d-flex flex-wrap justify-content-end align-items-center gap-2" v-if="booking.is_cancelled === false && !anyApplicantRescheduled && !anyApplicantCancelled">
                              <button v-if="isApplicationsEmpty" @click="callEntireEditApiFunction()"  class="btn reschedule-btn me-3">+ Add Applicant (None Added Yet)</button>
                            </div>
                          </div>

                          <div class="d-flex justify-content-start align-items-center" v-else>
                              <span style="color: #850000;">We're sorry, but it seems that the appointment date you have selected has already passed. Please choose a new appointment date.
                                If you need further assistance, 
                                please don't hesitate to contact us..! Ph: 0471 294 1938 | 1950 | 1312 
                                between 8.00 am and 5.30 pm, Monday to Saturday</span>
                          </div>
                        </div>
                        <div class="table-responsive mt-lg-4 mt-2" >
                          <table class="table responsive-table">
                            <thead>
                              <tr>
                                <th class="for-header">S.No</th>
                                <th class="for-header">Name</th>
                                <th class="for-header">Slot Date</th>
                                <th class="for-header">Slot Time</th>
                                <th class="for-header" v-if="hasPendingData">Pending</th>
                                <th class="for-header" v-if="!isApplicantSlotPassedOrNot"> Actions</th>
                              </tr>
                            </thead>

                            <tbody>
                              <template v-if="(booking.applications || []).some(app => (app.applicants || []).length)">
                                <template v-for="(application, appIdx) in booking.applications || []" :key="appIdx">
                                  <tr
                                    v-for="(applicant, index) in application.applicants || []"
                                    :key="applicant.id"
                                    >
                                    <td :class="{ 'text-decoration-line-through': booking.is_cancelled || applicant.cancel_status }">{{ getSerialNumber(appIdx, index) }}</td>
                                    <td class="name-cell" :class="{ 'text-decoration-line-through': booking.is_cancelled || applicant.cancel_status }">
                                        {{
                                        applicant.form_elements.find(el => el.field_name === 'givenname')?.field_value || 'N/A'
                                        }}
                                    </td>

                                    <td class="name-cell" :class="{ 'text-decoration-line-through': applicant.is_rescheduled || booking.is_cancelled || applicant.cancel_status }">
                                      {{ formatDate(booking.slot?.start_time) }}
                                    </td>
                                    <td class="name-cell-3" :class="{ 'text-decoration-line-through': applicant.is_rescheduled || booking.is_cancelled || applicant.cancel_status }">
                                      {{ formatTimeRange(booking.slot?.start_time, booking.slot?.end_time) }}
                                    </td>

                                    <td :key="progressKey" v-if="hasPendingData">
                                      <template
                                        v-for="(progress, i) in localProgress.filter(fp => Number(fp.applicant_id) === Number(applicant.id))"
                                        :key="i"
                                      >
                                        <template v-if="progress.empty.length > 0 && booking.is_cancelled === false && applicant.cancel_status === false ">
                                          <template v-if="applicant.is_rescheduled === false">
                                            <ul class="no-bullets">
                                              <li v-for="(field, j) in progress.empty.filter(f => f.has_medical_problem === false)" :key="j" class="mb-2">
                                                <!-- Upload UI (same as before) -->
                                                <div class="row align-items-center">
                                                  <div class="col-md-4 col-12 mb-2">
                                                    <label class="form-label mb-0 text-break">
                                                      {{ j + 1 }}. {{ formatKey(field.response_label) }}:
                                                    </label>
                                                  </div>
                                                  <div class="col-md-4 col-12 mb-2">
                                                    <label
                                                      :for="'file-' + applicant.id + '-' + j"
                                                      class="custom_upload btn btn-outline-secondary w-100"
                                                    >
                                                      Choose File
                                                    </label>
                                                    <input
                                                      type="file"
                                                      class="d-none"
                                                      :id="'file-' + applicant.id + '-' + j"
                                                      :name="'file_' + field.response_key"
                                                      accept=".pdf,.jpg,.jpeg,application/pdf,image/jpeg"
                                                      @change="handleFileUpload($event, applicant.id, field.response_key)"
                                                    >
                                                    <img
                                                      v-if="formData?.[applicant.id]?.[field.response_key] && isImage(formData[applicant.id][field.response_key])"
                                                      :src="formData[applicant.id][field.response_key]"
                                                      alt="Preview"
                                                      class="img-fluid mt-2"
                                                      style="max-height: 150px; border: 1px solid #ddd;"
                                                    >
                                                    <!-- PDF Preview -->
                                                    <div
                                                      v-else-if="formData?.[applicant.id]?.[field.response_key] && isPdf(formData[applicant.id][field.response_key])"
                                                      class="mt-2"
                                                    >
                                                      <embed
                                                        :src="formData[applicant.id][field.response_key]"
                                                        type="application/pdf"
                                                        width="100%"
                                                        height="150px"
                                                        style="border: 1px solid #ddd;"
                                                      />
                                                    </div>
                                                  </div>
                                                  <div class="col-md-4 col-12 mb-2">
                                                    <button
                                                      type="button"
                                                      class="btn btn-primary upload_submit w-100"
                                                      @click="submitFile(applicant.id, field.response_key, applicant.form_id, field.id, field.response_label)"
                                                    >
                                                      Submit
                                                    </button>
                                                  </div>
                                                </div>
                                              </li>
                                              <!-- Show when no pending documents -->
                                              <li 
                                                v-if="progress.empty.filter(f => f.has_medical_problem === false).length === 0" 
                                                class="text-center text-muted py-3"
                                              >
                                                No pending documents
                                              </li>
                                            </ul>
                                          </template>
                                          <!--  pending uploads but not upload for this applicant -->
                                          <span v-else class="mb-0 text-muted"> This appointment has been rescheduled. Please use the new booking number to view the details.</span>
                                        </template>

                                        <!--  No pending uploads for this applicant -->
                                        <span v-else>No pending uploads</span>
                                      </template>

                                      <!--  Applicant not found in formProgress at all -->
                                      <span
                                        v-if="!formProgress.some(fp => Number(fp.applicant_id) === Number(applicant.id))"
                                      >
                                        No progress data
                                      </span>
                                    </td>

                                    <td class="text-end" v-if="!isApplicantSlotPassedOrNot && booking.slot?.booking_closed === false && booking.is_cancelled === false">
                                      <div class="d-flex flex-wrap gap-2 align-items-center">
                                        <span v-if="applicant.is_rescheduled" class="text-success fw-bold me-2">Rescheduled</span>
                                        <span v-if="applicant.cancel_status" class="text-danger fw-bold me-2">Cancelled</span>

                                        <button class="btn reschedule-btn w-lg-100" v-if="booking.slot?.booking_closed === false && booking.is_cancelled === false && applicant.cancel_status === false && applicant.is_rescheduled === false " @click="SingleResheduleBooking(booking.id, booking.booking_no, booking.phone, booking.name, booking.email, applicant.id, applicant.form_elements.find(el => el.field_name === 'givenname')?.field_value || '')">Re-Schedule</button>
                                        <button class="btn cancel-btn w-lg-100" v-if="booking.slot?.booking_closed === false && booking.is_cancelled === false && applicant.cancel_status === false && applicant.is_rescheduled === false " @click="SingleConfirmCancel(booking.id, booking.booking_no, booking.phone, booking.name, booking.email, applicant.id, applicant.form_elements.find(el => el.field_name === 'givenname')?.field_value || '')">Cancel</button>
                                          <button
                                          class="btn edit-btn w-lg-100"
                                          v-if="booking.slot?.booking_closed === false && booking.is_cancelled === false && applicant.cancel_status === false  && applicant.is_rescheduled === false"
                                          @click="singleEdit(booking.id, booking.booking_no, booking.phone, booking.name, booking.email, applicant.id, applicant.form_elements.find(el => el.field_name === 'givenname')?.field_value || '')"
                                          >
                                          Edit
                                        </button>
                                      </div>
                                      
                                    </td>
                                  </tr>
                                </template>
                              </template>
                              <tr v-else>
                                <td colspan="5" class="text-center text-muted" style="color: rgb(153, 27 ,27, 1) !important;">Applicant details are incomplete. Please upload the required documents to track your appointment.</td>
                              </tr>
                            </tbody>

                          </table>
                        </div>
                        <div class="row mt-lg-5 Contact_Details align-items-end">
                          <p class="mb-0 text-muted">
                            For enquiries contact : 0471 294 1938 | 1950 | 1312 between 8.00 am and 5.30 pm, Monday to Saturday.
                          </p>
                          <div class="text-end Payment_Details">
                            <p class="mb-0 payment">Total Advance Amount</p>
                            <!-- <p class="mb-0">INR : {{ booking.payment?.amount || '0.00' }}</p> -->
                            <!-- <p class="mb-0">INR : {{ booking.total_paid || '0.00' }}</p> -->
                            <p class="mb-0">INR : {{ booking.total_paid != null && booking.total_paid != 0 ? booking.total_paid : booking.payment?.amount ?? '0.00' }}</p>
                            <p class="mb-0">Payment Method : {{ booking.payment?.method?.name || 'Razorpay' }}</p>
                            <p class="mb-0"><strong>Taxes included</strong></p>
                          </div>
                        </div>
                      </div>

                      
                      <!-- Pop Up for OTP -->
                      <div class="modal fade" id="otpCancelApplicantModal" tabindex="-1" aria-labelledby="otpModalLabel" aria-hidden="true">
                          <div class="modal-dialog modal-dialog-centered">
                            <div class="modal-content p-4 rounded-4">
                              <div class="modal-body">
                                <img src="@/assets/Images/Logo/kims-logo.png" alt="KIMSHEALTH" class="mb-3" style="max-width:260px;">
                                <p class="otp_text mb-4">Please Enter the OTP received on your registered mobile number</p>
                                <div class="d-flex justify-content-center mb-3 gap-1 otp-input-group flex-wrap justify-content-between">
                                  <input
                                      v-for="(digit, index) in otp"
                                      :key="index"
                                      type="text"
                                      inputmode="numeric"
                                      pattern="[0-9]*"
                                      class="form-control otp-box text-center"
                                      maxlength="1"
                                      v-model="otp[index]"
                                      @input="focusNext(index, $event)"
                                      @keydown.backspace="focusPrev(index, $event)"
                                      ref="otpInputs"
                                  />
                                  
                                </div>  
                                <small v-if="errors.otpError" class="text-danger">{{ errors.otpError }}</small>            
                                <a  @click="validationCancelApplicantMain()" :disabled="loading" class="btn confirm-btn w-100 mb-3">
                                  <span v-if="!loading">Confirm</span>
                                  <span v-else>
                                      <i class="fa fa-spinner fa-spin"></i> Processing...
                                  </span>
                                </a>
                                <div class="d-flex justify-content-between">
                                  <span class="resend">Resend OTP in <span class="timer">{{ formattedTime }}</span></span>
                                  <a href="#" class="resend_btn text-decoration-none" @click.prevent="handleResend()" :disabled="resendloading">
                                    <span v-if="!resendloading">Resend</span>
                                    <span v-else>
                                      <i class="fa fa-spinner fa-spin"></i> Resending...
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>


                      <!-- second popup for single cancel -->
                      <div class="modal fade" id="SingleotpModal" tabindex="-1" aria-labelledby="otpModalLabel" aria-hidden="true">
                          <div class="modal-dialog modal-dialog-centered">
                            <div class="modal-content p-4 rounded-4">
                              <div class="modal-body">
                                <img src="@/assets/Images/Logo/kims-logo.png" alt="KIMSHEALTH" class="mb-3" style="max-width:260px;">
                                <p class="otp_text mb-4">Please Enter the OTP received on your registered mobile number</p>
                                <div class="d-flex justify-content-center mb-3 gap-1 otp-input-group flex-wrap justify-content-between">
                                  <input
                                      v-for="(digit, index) in otpp"
                                      :key="index"
                                      type="text"
                                      inputmode="numeric"
                                      pattern="[0-9]*"
                                      class="form-control otp-box text-center"
                                      maxlength="1"
                                      v-model="otpp[index]"
                                      @input="focusNext2(index, $event)"
                                      @keydown.backspace="focusPrev2(index, $event)"
                                      ref="otpInputs1"
                                  />
                                  
                                </div>  
                                <small v-if="errors.otpError" class="text-danger">{{ errors.otpError }}</small>            
                                <a  @click="validationSingleCancelMain()" :disabled="loading" class="btn confirm-btn w-100 mb-3">
                                  <span v-if="!loading">Confirm</span>
                                  <span v-else>
                                      <i class="fa fa-spinner fa-spin"></i> Processing...
                                  </span>
                                </a>
                                <div class="d-flex justify-content-between">
                                  <span class="resend">Resend OTP in <span class="timer">{{ formattedTime }}</span></span>
                                  <a href="#" class="resend_btn text-decoration-none" @click.prevent="handleResend()" :disabled="resendloading">
                                    <span v-if="!resendloading">Resend</span>
                                    <span v-else>
                                      <i class="fa fa-spinner fa-spin"></i> Resending...
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>

                      <!-- Reshedule popup for entire booking -->
                      <div class="modal fade" id="otpModalReshedule" tabindex="-1" aria-labelledby="otpModalLabel" aria-hidden="true">
                          <div class="modal-dialog modal-dialog-centered">
                            <div class="modal-content p-4 rounded-4">
                              <div class="modal-body">
                                <img src="@/assets/Images/Logo/kims-logo.png" alt="KIMSHEALTH" class="mb-3" style="max-width:260px;">
                                <p class="otp_text mb-4">Please Enter the OTP received on your registered mobile number</p>
                                <div class="d-flex justify-content-center mb-3 gap-1 otp-input-group flex-wrap justify-content-between">
                                  <input
                                      v-for="(digit, index) in otppReshedule"
                                      :key="index"
                                      type="text"
                                      inputmode="numeric"
                                      pattern="[0-9]*"
                                      class="form-control otp-box text-center"
                                      maxlength="1"
                                      v-model="otppReshedule[index]"
                                      @input="focusNext3(index, $event)"
                                      @keydown.backspace="focusPrev3(index, $event)"
                                      ref="otpInputs2"
                                  />
                                  
                                </div>  
                                <small v-if="errors.otpError" class="text-danger">{{ errors.otpError }}</small>            
                                <a  @click="validationResheduleEntireMain()" :disabled="loading" class="btn confirm-btn w-100 mb-3">
                                  <span v-if="!loading">Confirm</span>
                                  <span v-else>
                                      <i class="fa fa-spinner fa-spin"></i> Processing...
                                  </span>
                                </a>
                                <div class="d-flex justify-content-between">
                                  <span class="resend">Resend OTP in <span class="timer">{{ formattedTime }}</span></span>
                                  <a href="#" class="resend_btn text-decoration-none" @click.prevent="handleResend()" :disabled="resendloading">
                                    <span v-if="!resendloading">Resend</span>
                                    <span v-else>
                                      <i class="fa fa-spinner fa-spin"></i> Resending...
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>

                      <!-- sINGLE Reshedule popup for SINGLE booking -->
                      <div class="modal fade" id="otpModalSingleReshedule" tabindex="-1" aria-labelledby="otpModalLabel" aria-hidden="true">
                          <div class="modal-dialog modal-dialog-centered">
                            <div class="modal-content p-4 rounded-4">
                              <div class="modal-body">
                                <img src="@/assets/Images/Logo/kims-logo.png" alt="KIMSHEALTH" class="mb-3" style="max-width:260px;">
                                <p class="otp_text mb-4">Please Enter the OTP received on your registered mobile number</p>
                                <div class="d-flex justify-content-center mb-3 gap-1 otp-input-group flex-wrap justify-content-between">
                                  <input
                                      v-for="(digit, index) in otpSingleReshedule"
                                      :key="index"
                                      type="text"
                                      inputmode="numeric"
                                      pattern="[0-9]*"
                                      class="form-control otp-box text-center"
                                      maxlength="1"
                                      v-model="otpSingleReshedule[index]"
                                      @input="focusNext4(index, $event)"
                                      @keydown.backspace="focusPrev4(index, $event)"
                                      ref="otpInputs3"
                                  />
                                  
                                </div>  
                                <small v-if="errors.otpError" class="text-danger">{{ errors.otpError }}</small>            
                                <a  @click="validationResheduleSingleMain()" :disabled="loading" class="btn confirm-btn w-100 mb-3">
                                  <span v-if="!loading">Confirm</span>
                                  <span v-else>
                                      <i class="fa fa-spinner fa-spin"></i> Processing...
                                  </span>
                                </a>
                                <div class="d-flex justify-content-between">
                                  <span class="resend">Resend OTP in <span class="timer">{{ formattedTime }}</span></span>
                                  <a href="#" class="resend_btn text-decoration-none" @click.prevent="handleResend()" :disabled="resendloading">
                                    <span v-if="!resendloading">Resend</span>
                                    <span v-else>
                                      <i class="fa fa-spinner fa-spin"></i> Resending...
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>


                      <!-- For editing model to single applicant -->
                      <div class="modal fade" id="otpModalSingleEdit" tabindex="-1" aria-labelledby="otpModalLabel" aria-hidden="true">
                          <div class="modal-dialog modal-dialog-centered">
                            <div class="modal-content p-4 rounded-4">
                              <div class="modal-body">
                                <img src="@/assets/Images/Logo/kims-logo.png" alt="KIMSHEALTH" class="mb-3" style="max-width:260px;">
                                <p class="otp_text mb-4">Please Enter the OTP received on your registered mobile number</p>
                                <div class="d-flex justify-content-center mb-3 gap-1 otp-input-group flex-wrap justify-content-between">
                                  <input
                                      v-for="(digit, index) in otpSingleEdit"
                                      :key="index"
                                      type="text"
                                      inputmode="numeric"
                                      pattern="[0-9]*"
                                      class="form-control otp-box text-center"
                                      maxlength="1"
                                      v-model="otpSingleEdit[index]"
                                      @input="focusNextEdit(index, $event)"
                                      @keydown.backspace="focusPrevEdit(index, $event)"
                                      ref="otpInputsEdit"
                                  />
                                  
                                </div>  
                                <small v-if="errors.otpError" class="text-danger">{{ errors.otpError }}</small>            
                                <button  @click="validationEditSingleMain()" :disabled="loading" class="btn confirm-btn w-100 mb-3">
                                  <span v-if="!loading">Confirm</span>
                                  <span v-else>
                                      <i class="fa fa-spinner fa-spin"></i> Processing...
                                  </span>
                                </button>
                                <div class="d-flex justify-content-between">
                                  <span class="resend">Resend OTP in <span class="timer">{{ formattedTime }}</span></span>
                                  <a href="#" class="resend_btn text-decoration-none" @click.prevent="handleResend()" :disabled="resendloading">
                                    <span v-if="!resendloading">Resend</span>
                                    <span v-else>
                                      <i class="fa fa-spinner fa-spin"></i> Resending...
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>

                      <!-- For ENTIRE editing model to single applicant -->
                      <div class="modal fade" id="otpModalEntireEdit" tabindex="-1" aria-labelledby="otpModalLabel" aria-hidden="true">
                          <div class="modal-dialog modal-dialog-centered">
                            <div class="modal-content p-4 rounded-4">
                              <div class="modal-body">
                                <img src="@/assets/Images/Logo/kims-logo.png" alt="KIMSHEALTH" class="mb-3" style="max-width:260px;">
                                <p class="otp_text mb-4">Please Enter the OTP received on your registered mobile number</p>
                                <div class="d-flex justify-content-center mb-3 gap-1 otp-input-group flex-wrap justify-content-between">
                                  <input
                                      v-for="(digit, index) in otpEntireEdit"
                                      :key="index"
                                      type="text"
                                      inputmode="numeric"
                                      pattern="[0-9]*"
                                      class="form-control otp-box text-center"
                                      maxlength="1"
                                      v-model="otpEntireEdit[index]"
                                      @input="focusNextEntireEdit(index, $event)"
                                      @keydown.backspace="focusPrevEntireEdit(index, $event)"
                                      ref="otpInputsEditEntire"
                                  />
                                  
                                </div>  
                                <small v-if="errors.otpError" class="text-danger">{{ errors.otpError }}</small>            
                                <a  @click="callEntireEditApiFunction()" :disabled="loading" class="btn confirm-btn w-100 mb-3">
                                  <span v-if="!loading">Confirm</span>
                                  <span v-else>
                                      <i class="fa fa-spinner fa-spin"></i> Processing...
                                  </span>
                                </a>
                                <div class="d-flex justify-content-between">
                                  <span class="resend">Resend OTP in <span class="timer">{{ formattedTime }}</span></span>
                                  <a href="#" class="resend_btn text-decoration-none" @click.prevent="handleResend()" :disabled="resendloading">
                                    <span v-if="!resendloading">Resend</span>
                                    <span v-else>
                                      <i class="fa fa-spinner fa-spin"></i> Resending...
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>



                    <!-- new member section  -->
                    <!-- Applicant Count Modal -->
                    <div class="modal fade" id="applicantModal" tabindex="-1" aria-labelledby="applicantModalLabel" aria-hidden="true" ref="modal">
                      <div class="modal-dialog modal-dialog-centered modal-small">
                        <div class="modal-content text-center">
                          <div class="modal-body">
                           
                            <h6 class="my-4">
                              Please select the number of additional adult members to add <span>{{ booking.slot.entity }}</span>?
                            </h6>

                            <p class="text-muted" v-if="booking?.slot">
                              Your existing booking is scheduled on <br>
                              <strong style="color: black;">{{ new Date(booking.slot.start_time.replace(/\//g, '-')).toLocaleDateString('en-GB', { day:'2-digit', month:'short', year:'numeric' }) }}</strong>
                              from 
                              <strong style="color: black;">{{ new Date(booking.slot.start_time.replace(/\//g, '-')).toLocaleTimeString('en-US', { hour:'numeric', minute:'2-digit', hour12:true }) }}</strong>
                              to 
                              <strong style="color: black;">{{ new Date(booking.slot.end_time.replace(/\//g, '-')).toLocaleTimeString('en-US', { hour:'numeric', minute:'2-digit', hour12:true }) }}</strong>.
                            </p>






                            <div class="btn-group mb-4" role="group" aria-label="Applicant count">
                              <!-- ensures the maximum value is 5. -->
                              <button
                                v-for="n in Math.min(Number(booking.slot.available_slot_count), 5)"
                                :key="n"
                                type="button"
                                class="applicant-btn"
                                :class="{ active: selectedApplicantCount === n }"
                                @click="selectApplicantCount(n)"
                              >
                                {{ n }}
                              </button>
                            </div>
                            <div class="d-flex justify-content-between gap-3">
                              <button class="btn btn-cancel w-50" data-bs-dismiss="modal">Cancel</button>
                              <button class="btn btn-next w-50" @click="showInstructionModal" :disabled="!selectedApplicantCount">Next</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
  
                    <!-- Instruction Modal -->
                    <div class="modal fade" id="instructionModal" tabindex="-1" aria-labelledby="instructionModalLabel" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content p-4 rounded-4">
                          <div class="modal-header border-0 pb-0">
                            <h5 class="modal-title fw-semibold" id="instructionModalLabel">
                              Document Required for Visa Medical
                            </h5>
                            <button
                              type="button"
                              class="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>
                          <div class="modal-body text-start pt-1">
                            <p class="text-danger fw-semibold mb-3">
                              Keep following documents handy before proceeding next:
                            </p>
                
                            

                            <!-- <div v-if="selectedInstructions && selectedInstructions.length">
                              <div v-html="showFullInstructions ? selectedInstructions : truncatedInstructions"></div>
                              <button
                                v-if="selectedInstructions.split(' ').length > 50"
                                class="btn btn-link p-0 mt-2"
                                @click="toggleInstructions"
                              >
                                {{ showFullInstructions ? 'Read Less' : 'Read More' }}
                              </button>
                            </div> -->
                            <div v-if="selectedInstructions && selectedInstructions.length" class="instruction-scroll">
                              <div v-html="cleanInstructions" class="word-break"></div>
                            </div>
                
                            <p v-else class="text-muted">No instructions available for this country.</p>
                
                            <div class="d-flex justify-content-between gap-2 mt-4">
                              <button
                                type="button"
                                class="btn btn-cancel w-50"
                                data-bs-dismiss="modal"
                              >
                                Cancel
                              </button>
                              <!-- Use dynamic URL with entity ID and applicant count -->
                              <button
                              class="btn btn-next w-50"
                              @click="goToNewMember"
                              :disabled="!selectedApplicantCount"
                            >
                              Next
                            </button>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                      

                      

                      <div id="preloader" v-if="entirePageLoading" style="position: fixed; top:0; left:0; width:100%; height:100%; background: rgba(255,255,255,0.8); z-index: 9999; display:flex; flex-direction:column; justify-content:center; align-items:center;">
                        <img src="@/assets/Images/Logo/preloader.png" alt="Loading Image" style="width:100px;">
                        <p>Loading...</p>
                      </div>

  </div>

</template>
                    

                    
<script>
    import Swal from 'sweetalert2';
    import { RescheduleEntireBooking, LogoutPage } from '@/api/Post/action.js';
    import 'bootstrap/dist/js/bootstrap.bundle.min.js';
    import { useUserStore } from '@/store/user';
    import { PurposeSendOtp, PurposeVerifyOtp, PurposeCancelAllBookings, PurposeCancelSingleBookings } from '@/api/Post/track.js';
    import { SlotsPediatricFriendly, SlotsByDate } from "@/api/Post/slot";
    import ResheduleEntireDetails from '@/components/Appointment/Sections/Details/ResheduleEntireDetails.vue';
    import { GetFormApplicant, GetApplicantData, PassPortCheck, UpdateApplicantDetails, UpdatePendingApplicantDetails} from '@/api/Post/form';
    import { GetSingleEntities } from '@/api/Front/home';
    import { ResponseBooking, GetRazorKey, LoadFormNumber, PaymentResponse } from "@/api/Post/payment.js";
    export default {
      name: 'ViewDetailsMore',
      props: {
        booking: {
          type: [String, Object, Number], 
          required: false
        },
        formProgress: {
          type: Object,
          required: false,
          default: () => ({})
        },  
      },
      computed: {
        formattedTime() {
          const minutes = Math.floor(this.timer / 60);
          const seconds = this.timer % 60;
          return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        },

        isApplicationsEmpty() {
          ///console.log('hai bab:');
          return !this.booking?.applications || this.booking.applications.length === 0;
        },

        isTotalApplicantNotMatchApplications() {
          const total = this.booking?.totalapplicants || 0;
          const totalApplicants = this.booking?.applications?.reduce(
            (sum, app) => sum + (Array.isArray(app.applicants) ? app.applicants.length : 0),
            0
          ) || 0;
          ///console.log('total : ', total, 'totalApplicants :', totalApplicants);
          return total > totalApplicants;
        },


        anyApplicantRescheduled() {
          return this.booking.applications?.some(application =>
            application.applicants?.some(applicant => applicant.is_rescheduled === true)
          );
        },
        anyApplicantCancelled() {
          //console.log('vishnu');
          return this.booking.applications?.some(application =>
            application.applicants?.some(applicant => applicant.cancel_status === true)
          );
        },
        truncatedInstructions() {
          const words = this.selectedInstructions.split(' ');
          if (words.length <= 50) return this.selectedInstructions;
          return words.slice(0, 50).join(' ') + '...';
        },
        cleanInstructions() {
          if (!this.selectedInstructions) return '';

          // Create a temporary DOM element
          const temp = document.createElement('div');
          temp.innerHTML = this.selectedInstructions;

          // Remove empty <p> tags
          const paragraphs = temp.querySelectorAll('p');
          paragraphs.forEach(p => {
            if (!p.textContent.trim()) p.remove();
          });

          return temp.innerHTML;
        },

        isApplicantSlotPassedOrNot() {
          if (!this.booking?.slot?.start_time) return false;
          // Convert the start_time string to a valid Date object
          const startTime = new Date(this.booking.slot.start_time.replace(/\//g, '-')); 
          const now = new Date();
          // Return true if current time is after the slot's start time
          ///console.log('now > startTime : ', now > startTime);
          return now > startTime;
        },

        canAddApplicantToday() {
          return this.isSlotToday && this.isApplicantSlotPassedOrNot && this.isBeforeToday5pm;
        },

        isSlotToday() {
          if (!this.booking?.slot?.start_time) return false;

          const slotDate = new Date(this.booking.slot.start_time.replace(/\//g, '-'));
          const now = new Date();

          return slotDate.toDateString() === now.toDateString();
        },

        isBeforeToday5pm() {
          const now = new Date();

          // today 17:00 (5 PM)
          const fivePm = new Date();
          fivePm.setHours(17, 0, 0, 0);//5PM
          //fivePm.setHours(18, 0, 0, 0); //6PM
          //fivePm.setHours(19, 0, 0, 0); //7PM

          return now <= fivePm;
        },

        hasPendingData() {
          // true only if at least one applicant has a pending item where has_medical_problem == false
          return this.localProgress.some(fp =>
            fp.empty &&
            fp.empty.some(f => f.has_medical_problem === false)
          );
        }
      },
      mounted() {
        localStorage.setItem('totalApplicantFromEntirePage', this.booking.totalapplicants);
        const totalApplicants = this.booking.applications.reduce(
          (sum, app) => sum + (Array.isArray(app.applicants) ? app.applicants.length : 0),
          0
        );
        ///console.log('totalApplicants :', totalApplicants);
        localStorage.setItem('applicationsLength', totalApplicants);
        localStorage.setItem('totalbooking_no', this.booking.booking_no);
        localStorage.setItem('enitrbooking_adults', this.booking.adults);
        localStorage.setItem('enitrbooking_applicants', this.booking.totalapplicants);
        localStorage.setItem('enitrbooking_childs', this.booking.childs);
        localStorage.setItem('enitrbooking_id', this.booking.id);
        localStorage.setItem('enitrbooking_entity_id', this.booking.slot.entity_id);
        ///console.log('The entity id:', JSON.stringify(this.booking.slot));
        // if (this.timer > 0) {
        //     this.startTimer();
        // } else {
        //     console.error("Invalid expire_in value:", this.timer);  
        // }
        ///console.log('Form Progress:', JSON.stringify(this.formProgress, null, 2));
        this.localProgress = JSON.parse(JSON.stringify(this.formProgress));

        const modalIds = [
          'otpModalSingleEdit',
          'SingleotpModal',
          'otpModalReshedule',
          'otpModalSingleReshedule',
          'otpCancelApplicantModal'
        ];

        modalIds.forEach(id => {
          const modal = document.getElementById(id);
          if (modal) {
            modal.addEventListener('hide.bs.modal', () => {
              // Fix focus issue BEFORE modal hides
              const active = document.activeElement;
              if (active && modal.contains(active)) {
                active.blur();
              }

              this.resetAllOtpStates();
            });
          }
        });
      },
      watch: {
        showNextComponent(val) {
          if (val) {
            ///console.log("Booking passed to child:", this.booking);
          }
        },
      },

      data() {
        const otpData = {
          expire_in: 3
        };
        let expireInMinutes = parseInt(otpData.expire_in); 
        let expireInSeconds = expireInMinutes * 60;

        if (isNaN(expireInSeconds)) {
            console.error("Invalid expire_in value:", otpData.expire_in);
            expireInSeconds = 180; 
        }
        return {
            otp: ['', '', '', '', ''],
            otpp: ['', '', '', '', ''],
            otppReshedule: ['', '', '', '', ''],
            otpSingleReshedule: ['', '', '', '', ''],
            otpSingleEdit: ['', '', '', '', ''],
            otpEntireEdit: ['', '', '', '', ''],
            errors: {},
            loading : false,
            timer: expireInSeconds, 
            otpData: otpData,
            timerActive: true,
            resendloading: false,
            resendCount: 0,
            resendDisabled: false,
            phoneNumber: '',
            name: '',
            email: '',
            participant: '',
            bookingId: '',
            applicant_id: '',
            entirePageLoading: false,
            fileUploads: {},
            formData: {} ,
            progressKey: 0,
            localProgress: [],
            applicant_name: null,
            booking_no: null,
            // selectedEntity: {},
            selectedApplicantCount: null,
            selectedInstructions: '',
            showFullInstructions: false,
            isOverflow: false,
        };
      },
      methods: {

      handleFileUpload(event, applicantId, responseKey) {
        const files = event.target.files;
        if (!files.length) return;

        const file = files[0];

        if (!this.formData) this.formData = {};
        if (!this.formData[applicantId]) this.formData[applicantId] = {};

        const reader = new FileReader();

        reader.onload = async () => {
          const base64String = reader.result;
          this.formData[applicantId][responseKey] = base64String;

          if (responseKey === 'attachpassport') {
            try {
              const result = await PassPortCheck(base64String.split(',')[1]);
              if (!result.success) {
                Swal.fire({
                  title: 'Attention!',
                  text: 'We are unable to read the details from your passport. Please ensure both sides are included.',
                  confirmButtonText: 'Close',
                  customClass: {
                    popup: 'custom-error-alert',
                    confirmButton: 'white-confirm-button'
                  },
                  showClass: {
                    popup: 'animate__animated animate__shakeX'
                  },
                  hideClass: {
                    popup: 'animate__animated animate__fadeOutUp'
                  }
                });
              }
            } catch (error) {
              Swal.fire({
                title: 'Error',
                text: error.response?.data?.message || 'Upload failed!',
                icon: 'error',
                confirmButtonText: 'OK'
              });
            }
          }
        };

        reader.readAsDataURL(file);
      },



      async submitFile(applicantId, responseKey, formId, fieldId, response_label) {
       
        const base64 = this.formData?.[applicantId]?.[responseKey];
        //const file = this.fileUploads?.[applicantId]?.[responseKey];
        if (!base64) {
          // alert(`Please select a file for ${this.formatKey(response_label)}`);
          alert(`${this.formatKey(response_label)}`);
          return;
        }

        const payload = {
          ['applicant_id'] : applicantId,
          ['response_key']: responseKey,
          ['id']: fieldId,
          ['response'] : base64
        };

        const confirmation = await Swal.fire({
          title: 'Are you sure?',
          text: 'Do you really want to submit this file?',
          showCancelButton: true,
          confirmButtonText: 'Yes, submit it!',
          cancelButtonText: 'Cancel',
          reverseButtons: true,
          showClass: {
            popup: `animate__animated animate__fadeInUp animate__faster`,
          },
          hideClass: {
            popup: `animate__animated animate__fadeOutDown animate__faster`,
          }
        });

         if (!confirmation.isConfirmed) return;

        try {
          ///console.log('Submitting payload:', payload);
          await UpdatePendingApplicantDetails(payload); 

          Swal.fire({
            title: 'Success!',
            text: 'File uploaded successfully.',
            timer: 2000,
            showConfirmButton: false,
            toast: true,
            position: 'top-end',
            customClass: {
              popup: 'swal-success-toast'
            }
          });

          const progress = this.localProgress.find(p => Number(p.applicant_id) === Number(applicantId));
          if (progress) {
            progress.empty = progress.empty.filter(f => f.response_key !== responseKey);
          }

          this.progressKey++;

        } catch (error) {
          console.error('Upload failed:', error);
          Swal.fire({
            title: 'Error',
            text: error.response?.data?.message || 'Upload failed!',
            confirmButtonText: 'OK'
          });
        }
      },


      isImage(base64) {
        return typeof base64 === 'string' && base64.startsWith('data:image/');
      },
      isPdf(base64) {
        return typeof base64 === 'string' && base64.startsWith('data:application/pdf');
      },


      getSerialNumber(appIdx, applicantIdx) {
        if (!this.booking || !this.booking.applications) return 0;

        let count = 0;
        for (let i = 0; i < appIdx; i++) {
          // safely handle missing applicants array
          count += (this.booking.applications[i].applicants || []).length;
        }

        return count + (applicantIdx + 1);
      },
      

      async callEntireEditApiFunction() {

        //console.log('check booking token accept payment : ', this.booking?.booking_token?.accept_payment);
        if (!this.booking) {
          Swal.fire({                
            title: 'Booking Not Loaded',
            text: 'Booking details are not yet available. Please wait and try again.',
            confirmButtonColor: '#d33',
            confirmButtonText: 'OK'
          });
          //console.log('Booking not loaded yet');
          return;
        }

        // if (this.booking.payment === null && (!this.booking.booking_token || !this.booking.booking_token.id)) {
        //   Swal.fire({                
        //     title: 'Booking Not Loaded',
        //     text: 'Booking details are not yet available. Please wait and try again.',
        //     confirmButtonColor: '#d33',
        //     confirmButtonText: 'OK'
        //   });
        //   return;
        // }

        if (this.booking?.booking_token?.accept_payment === true) {
          // Payment already done → Load form and STOP
          if (this.booking?.payment) {
            GetFormApplicant(this.booking.slot.entity_id)
            .then((response) => {
              localStorage.removeItem('form_response');
              localStorage.setItem('form_response', JSON.stringify(response.data)); 
              this.$emit('change-view', 'detailsEntirePageEdit');
            })
            .catch((error) => {
              //console.error("Data fetch error:", error);
              this.errors.otpError = "Failed to load required data. Please try again.";
            })
            .finally(() => {
              this.entirePageLoading = false;
            });
            return;
          }

          // Booking details missing
          let offlineBookingDetails = null;
          if (this.booking?.booking_token?.booking_details) {
            offlineBookingDetails = JSON.parse(this.booking.booking_token.booking_details);
          } else {
            Swal.fire({
              title: 'No Booking Details',
              text: 'Booking details not found. Please contact support.',
              confirmButtonText: 'OK',   
              confirmButtonColor: '#3085d6'
            });
            return; 
          }
          //console.log('offlineBookingDetails :', offlineBookingDetails);
          //console.log('this.booking :', this.booking.name);
          //console.log('this.booking :', this.booking.email);
          //console.log('this.booking :', this.booking.phone);
          //console.log('offlineBookingDetails.booking_id :', offlineBookingDetails.booking_id);
          //return;

          // Continue Razorpay
          const keyRes = await GetRazorKey();
          const razorpayKey = keyRes.data.data.key;
          //console.log('Razorpay Key:', razorpayKey);

          const options = {
            key: razorpayKey,
            //amount: offlineBookingDetails.amount * 100,
            amount: Math.round(offlineBookingDetails.amount * 100),
            currency: offlineBookingDetails.currency,
            name: "KIMSHEALTH",
            description: "Visa Medical Slot Booking",
            order_id: offlineBookingDetails.order_id,
            prefill: {
              name: this.booking.name,
              email: this.booking.email,
              contact: this.booking.phone
            },
            notes: {
              booking_id: offlineBookingDetails.booking_id
            },
            theme: {
              color: "#FF0000"  // RED THEME
            },
            handler: async (paymentResponse) => {
              //console.log("Payment Success:", paymentResponse);
              try {
                this.entirePageLoading = true;
                    
                const entiti_id = this.booking.slot.entity_id;
                //console.log("entiti_id:", entiti_id);

                const response = await PaymentResponse(
                  offlineBookingDetails.booking_id,
                  offlineBookingDetails.amount,
                  1, // Razorpay
                  paymentResponse.razorpay_order_id,
                  paymentResponse.razorpay_payment_id,
                  paymentResponse.razorpay_signature,
                );

                //console.log("Payment Response:", response.data);
                const paymentData = response.data;

                localStorage.removeItem('bookingbookingDetails');
                localStorage.setItem('bookingbookingDetails', JSON.stringify(offlineBookingDetails));

                localStorage.removeItem('bookingPayment');
                localStorage.setItem('bookingPayment', JSON.stringify(paymentData));

                GetFormApplicant(this.booking.slot.entity_id)
                .then((response) => {
                  localStorage.removeItem('form_response');
                  localStorage.setItem('form_response', JSON.stringify(response.data)); 
                  this.$emit('change-view', 'detailsEntirePageEdit');
                })
                .catch((error) => {
                  //console.error("Data fetch error:", error);
                  this.errors.otpError = "Failed to load required data. Please try again.";
                })
                .finally(() => {
                  this.entirePageLoading = false;
                });
                    

              } catch (error) {
                this.$toast.error('Payment failed or verification failed!', {
                  position: 'top-right',
                  duration: 3000,
                });
                //console.error("Error:", error);
              } finally {
                this.entirePageLoading = false;
              }
            },

          };
          //console.log('options :', options);
          const rzp = new Razorpay(options);
          // Payment failed listener
          rzp.on('payment.failed', function(response) {
            //console.error('Payment Failed:', response.error);
            this.$toast.error('Payment failed! Please try again.', { position: 'top-right', duration: 3000 });
          }.bind(this));
          // Open Razorpay popup
          setTimeout(() => rzp.open(), 250);
          return;

        }

        this.entirePageLoading = true;
        GetFormApplicant(this.booking.slot.entity_id)
        .then((response) => {
          localStorage.removeItem('form_response');
          localStorage.setItem('form_response', JSON.stringify(response.data)); 
          this.$emit('change-view', 'detailsEntirePageEdit');
        })
        .catch((error) => {
          ///console.error("Data fetch error:", error);
          this.errors.otpError = "Failed to load required data. Please try again.";
        })
        .finally(() => {
          this.entirePageLoading = false;
        });

      },


      async callEditNewMemberApiFunction() {
        this.entirePageLoading = true;
        GetFormApplicant(this.booking.slot.entity_id)
          .then((response) => {
            localStorage.removeItem('form_response');
            localStorage.setItem('form_response', JSON.stringify(response.data)); 
            this.$emit('change-view', 'detailsEditNewMember');
          })
          .catch((error) => {
            console.error("Data fetch error:", error);
            this.errors.otpError = "Failed to load required data. Please try again.";
          })
          .finally(() => {
            this.entirePageLoading = false;
      });
      },


      focusNextEntireEdit(index, event) {
        if (event.target.value && index < 4) {
          this.$refs.otpInputsEditEntire[index + 1].focus();
        }
      },
      focusPrevEntireEdit(index, event) {
        if (!this.otpEntireEdit[index] && index > 0) {
          this.$refs.otpInputsEditEntire[index - 1].focus();
        }
      },

      formatDate(date) {
        if (!date) return 'N/A';
        return new Date(date).toLocaleDateString(undefined, {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        });
      },
      formatTimeRange(start, end) {
        if (!start || !end) return 'N/A';
        const s = new Date(start).toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        });
        const e = new Date(end).toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        });
        return `${s} - ${e}`;
      },

      async confirmReschedule(bookingId, booking_no, phoneNumber, name, email) {
        const result = await Swal.fire({
          title: 'Are you sure?',
          html: `Do you want to reschedule this appointment <span style="color: black; font-weight: bold;">${booking_no}</span>?`,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, reschedule it!',
          cancelButtonText: "Don't, reschedule",
          showClass: {
            popup: `animate__animated animate__fadeInUp animate__faster`,
          },
          hideClass: {
            popup: `animate__animated animate__fadeOutDown animate__faster`,
          }
        });

        if (!result.isConfirmed) return;

        const userStore = useUserStore();
        const loggedUser = userStore.user;
        let participant = loggedUser?.user_id;

        if (!participant) {
          const localUser = JSON.parse(localStorage.getItem('userId'));
          participant = localUser?.user_id || null;
        }

        if (!participant) {
          console.error("No user_id found in store or localStorage.");
          this.errors.otpError = "Session expired. Please log in again.";
          return;
        }

        const purpose = 'Reschedule';
        this.bookingId = bookingId;

        Swal.fire({
          title: 'Sending OTP...',
          text: 'Please wait while we send an OTP to your registered mobile number.',
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        this.phoneNumber = phoneNumber;
        this.name = name;
        this.email = email;
        this.participant = participant;

        try {

          const resheduleApplicantData = {
              booking_no,
              phoneNumber,
              name,
              email
          };
          localStorage.setItem('resheduleApplicantData', JSON.stringify(resheduleApplicantData));

          const response = await PurposeSendOtp(participant, phoneNumber, purpose, name, email);
          Swal.close();

          if (response.data.success === false) {
            this.errors.otpError = response.data.message || 'Something went wrong.';
            return;
          }

          this.resendCount++;
          this.timer = 180; 
          this.timerActive = true;
          //this.formattedTime = this.formatTime(this.timer);
          this.startTimer();

          if (this.resendCount >= 1) {
            this.resendDisabled = true;
            setTimeout(() => {
              this.resendCount = 0;
              this.resendDisabled = false;
            }, 5 * 60 * 1000);
            
          }

          ///console.log("OTP sent successfully.");
        } catch (error) {
          //console.error("Axios Error:", error);
          Swal.close();
          this.errors.otpError = "Failed to send OTP. Please try again.";
          return;
        }

        this.$nextTick(() => {
          const modalEl = document.getElementById('otpModalReshedule');
          if (modalEl) {
            const otpModal = new bootstrap.Modal(modalEl);
            otpModal.show();
          }
        });
        
      },

      async validationResheduleEntireMain() {
        

        const enteredOtp = this.otppReshedule.join('');
        this.errors.otpError = '';
        if (enteredOtp.length !== 5 || this.otppReshedule.some(digit => digit === '')) {
          this.errors.otpError = "Please enter a valid 5-digit OTP.";
          return;
        }

        this.loading = true;

        const userStore = useUserStore();
        const loggedUser = userStore.user;
        let participant = loggedUser?.user_id;

        if (!participant) {
          const localUser = JSON.parse(localStorage.getItem('userId'));
          participant = localUser?.user_id || null;
        }

        if (!participant) {
          console.error("No user_id found in store or localStorage.");
          this.errors.otpError = "Session expired. Please log in again.";
          return;
        }

        const purpose = 'Reschedule';
        
        PurposeVerifyOtp(participant, purpose, enteredOtp)
          .then((response) => {
            const res = response.data;

            if (!res.success || !res.verified) {
              this.errors.otpError = 'OTP is Invalid or Expired.';
              return;
            }
            //this.entirePageLoading = true;
            ///console.log('this.applicant_id:', this.applicant_id);
            // OTP verified, proceed to cancel bookings
            
            
            const modalEl = document.getElementById('otpModalReshedule');
            if (modalEl) {
              const otpModal = bootstrap.Modal.getInstance(modalEl);
              if (otpModal) otpModal.hide();
            }

            //this.showNextComponent = true;
            this.$emit('change-view', 'detailsReschedule');
            // this.$router.push({
            //   name: 'detailsResheduleEntireBooking',
            //   state: { booking: this.booking }
            // });

            
               
          })
          .catch((error) => {
            if (error.response && error.response.data) {
              const serverMessage = error.response.data.message;
              console.error("Backend Error:", serverMessage);
              this.errors.otpError = serverMessage || "Something went wrong. Please try again.";
            } else if (error.request) {
              console.error("No response received:", error.request);
              this.errors.otpError = "No response from server. Please check your internet or try again.";
            } else {
              console.error("Request setup error:", error.message);
              this.errors.otpError = error.message || "Something went wrong.";
            }
          })
          .finally(() => {
            this.loading = false;
          });



        
      },

      async validationResheduleSingleMain() {
        const enteredOtp = this.otpSingleReshedule.join('');
          this.errors.otpError = '';
          if (enteredOtp.length !== 5 || this.otpSingleReshedule.some(digit => digit === '')) {
            this.errors.otpError = "Please enter a valid 5-digit OTP.";
            return;
          }

          this.loading = true;

          const userStore = useUserStore();
          const loggedUser = userStore.user;
          let participant = loggedUser?.user_id;

          if (!participant) {
            const localUser = JSON.parse(localStorage.getItem('userId'));
            participant = localUser?.user_id || null;
          }

          if (!participant) {
            console.error("No user_id found in store or localStorage.");
            this.errors.otpError = "Session expired. Please log in again.";
            return;
          }

          const purpose = 'Reschedule';
          
          PurposeVerifyOtp(participant, purpose, enteredOtp)
            .then((response) => {
              const res = response.data;

              if (!res.success || !res.verified) {
                this.errors.otpError = 'OTP is Invalid or Expired.';
                return;
              }
              //this.entirePageLoading = true;
              //console.log('this.applicant_id:', this.applicant_id);
              // OTP verified, proceed to cancel bookings
              
              
              const modalEl = document.getElementById('otpModalSingleReshedule');
              if (modalEl) {
                const otpModal = bootstrap.Modal.getInstance(modalEl);
                if (otpModal) otpModal.hide();
              }

              //this.showNextComponent = true;
              //console.log('change view:');
              // this.$emit('change-view', {
              //   view: 'detailsResheduleSingleBooking',
              //   applicant_id: this.applicant_id
              // });
              localStorage.setItem('applicant_id', this.applicant_id);
              this.$emit('change-view', 'detailsSingleReschedule');
              // this.$router.push({
              //   name: 'detailsResheduleEntireBooking',
              //   state: { booking: this.booking }
              // });

              
                
            })
            .catch((error) => {
              if (error.response && error.response.data) {
                const serverMessage = error.response.data.message;
                console.error("Backend Error:", serverMessage);
                this.errors.otpError = serverMessage || "Something went wrong. Please try again.";
              } else if (error.request) {
                console.error("No response received:", error.request);
                this.errors.otpError = "No response from server. Please check your internet or try again.";
              } else {
                console.error("Request setup error:", error.message);
                this.errors.otpError = error.message || "Something went wrong.";
              }
            })
            .finally(() => {
              this.loading = false;
            });
      },

      focusNext3(index, event) {
        if (event.target.value && index < 4) {
          this.$refs.otpInputs2[index + 1].focus();
        }
      },
      focusPrev3(index, event) {
        if (!this.otppReshedule[index] && index > 0) {
          this.$refs.otpInputs2[index - 1].focus();
        }
      },

      focusNext4(index, event) {
        if (event.target.value && index < 4) {
          this.$refs.otpInputs3[index + 1].focus();
        }
      },
      focusPrev4(index, event) {
        if (!this.otpSingleReshedule[index] && index > 0) {
          this.$refs.otpInputs3[index - 1].focus();
        }
      },

      performReschedule(bookingId) {
        ///console.log("bookingId :", bookingId);
          RescheduleEntireBooking(bookingId)
            .then((response) => {
              if (response.data.success === false) {
                this.$toast.error(response.data.message || 'Something went wrong.', {
                  position: 'top-right',
                  duration: 3000,
                });
              } else {
                ///console.log("Rescheduling...");
                this.$toast.success(response.data.message || 'Something went wrong.', {
                  position: 'top-right',
                  duration: 3000,
                });
              }
            })
            .catch((error) => {
              console.error("Axios Error:", error);

              if (error.response && error.response.data) {
                this.$toast.error(error.response.data.message || 'Something went wrong.', {
                  position: 'top-right',
                  duration: 3000,
                });
              } else if (error.message) {
                this.$toast.error(`Request error: ${error.message}`, {
                  position: 'top-right',
                  duration: 3000,
                });
              } else {
                this.$toast.error('An unknown error occurred.', {
                  position: 'top-right',
                  duration: 3000,
                });
              }
            })
            .finally(() => {

            });
      },


      async confirmApplicationEntireCancel(bookingId, booking_no, phoneNumber, name, email) {
        const result = await Swal.fire({
          title: 'Are you sure?',
          html: `This action will cancel the appointment with booking number <span style="color: black; font-weight: bold;">${booking_no}</span>.`,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, cancel it!',
          cancelButtonText: "Don't, Cancel",
          showClass: {
            popup: `animate__animated animate__fadeInUp animate__faster`,
          },
          hideClass: {
            popup: `animate__animated animate__fadeOutDown animate__faster`,
          }
        });

        if (!result.isConfirmed) return;

        const userStore = useUserStore();
        const loggedUser = userStore.user;
        let participant = loggedUser?.user_id;

        if (!participant) {
          const localUser = JSON.parse(localStorage.getItem('userId'));
          participant = localUser?.user_id || null;
        }

        if (!participant) {
          console.error("No user_id found in store or localStorage.");
          this.errors.otpError = "Session expired. Please log in again.";
          return;
        }

        const purpose = 'Cancel';
        this.bookingId = bookingId;

        Swal.fire({
          title: 'Sending OTP...',
          text: 'Please wait while we send an OTP to your registered mobile number.',
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        this.phoneNumber = phoneNumber;
        this.name = name;
        this.email = email;
        this.participant = participant;
        this.booking_no = booking_no;

        try {
          const response = await PurposeSendOtp(participant, phoneNumber, purpose, name, email);
          Swal.close();

          if (response.data.success === false) {
            this.errors.otpError = response.data.message || 'Something went wrong.';
            return;
          }

          this.resendCount++;
          this.timer = 180; 
          this.timerActive = true;
          //this.formattedTime = this.formatTime(this.timer);
          this.startTimer();

          if (this.resendCount >= 1) {
            this.resendDisabled = true;
            setTimeout(() => {
              this.resendCount = 0;
              this.resendDisabled = false;
            }, 5 * 60 * 1000);
            
          }

          ///console.log("OTP sent successfully.");
        } catch (error) {
          console.error("Axios Error:", error);
          Swal.close();
          this.errors.otpError = "Failed to send OTP. Please try again.";
          return;
        }

        this.$nextTick(() => {
          const modalEl = document.getElementById('otpCancelApplicantModal');
          if (modalEl) {
            const otpModal = new bootstrap.Modal(modalEl);
            otpModal.show();
          }
        });
      },



      focusNext(index, event) {
        if (event.target.value && index < 4) {
          this.$refs.otpInputs[index + 1].focus();
        }
      },
      focusPrev(index, event) {
        if (!this.otp[index] && index > 0) {
          this.$refs.otpInputs[index - 1].focus();
        }
      },

      async validationCancelApplicantMain() {
        

        const enteredOtp = this.otp.join('');
        this.errors.otpError = '';
        if (enteredOtp.length !== 5 || this.otp.some(digit => digit === '')) {
          this.errors.otpError = "Please enter a valid 5-digit OTP.";
          return;
        }

        this.loading = true;

        const userStore = useUserStore();
        const loggedUser = userStore.user;
        let participant = loggedUser?.user_id;

        if (!participant) {
          const localUser = JSON.parse(localStorage.getItem('userId'));
          participant = localUser?.user_id || null;
        }

        if (!participant) {
          console.error("No user_id found in store or localStorage.");
          this.errors.otpError = "Session expired. Please log in again.";
          return;
        }

        const purpose = 'Cancel';
        
        PurposeVerifyOtp(participant, purpose, enteredOtp)
          .then((response) => {
            const res = response.data;

            if (!res.success || !res.verified) {
              this.errors.otpError = 'OTP is Invalid or Expired.';
              return;
            }

            // OTP verified, proceed to cancel bookings
            ///console.log('this.bookingId : view more  : ', this.bookingId)
            return PurposeCancelAllBookings(enteredOtp, this.bookingId)
              .then((cancelResponse) => {
                const cancelRes = cancelResponse.data;
                ///console.log("Cancel Response:", cancelRes);
                if (cancelRes.success === true || cancelRes.success === 'true') {
                  Swal.fire({
                    title: `Booking #${this.booking_no}`,
                    text: cancelRes.message || 'Bookings cancelled successfully.',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    showClass: {
                      popup: 'animate__animated animate__fadeInDown',
                    },
                    hideClass: {
                      popup: 'animate__animated animate__fadeOutUp',
                    },
                    customClass: {
                      confirmButton: 'my-red-button',
                    },
                   }).then(() => {
                      LogoutPage()
                        .then(() => {
                          localStorage.removeItem('authToken');
                          this.$router.push({ name: 'trackAppointment' });
                        })
                        .catch((error) => {
                          console.error("Logout Error:", error);

                          Swal.fire({
                            title: 'Logout failed. Please try again.',
                            showConfirmButton: false,
                            timer: 3000,
                            timerProgressBar: true,
                            showClass: {
                              popup: 'animate__animated animate__shakeX'
                            },
                            hideClass: {
                              popup: 'animate__animated animate__fadeOutUp'
                            }
                          });
                        });
                   });

                  // setTimeout(() => {
                    
                  // }, 2000);
                  
                } else {
                  this.$toast.error(cancelRes.message || 'Failed to cancel bookings.', {
                    position: 'top-right',
                    duration: 3000,
                  });
                }
              })
              .catch((error) => {
                console.error("CancelAllBookings Error:", error);
                this.$toast.error('Failed to cancel bookings. Please try again.', {
                  position: 'top-right',
                  duration: 3000,
                });
              })
              .finally(() => {
                const modalEl = document.getElementById('otpCancelApplicantModal');
                if (modalEl) {
                  const otpModal = bootstrap.Modal.getInstance(modalEl);
                  if (otpModal) otpModal.hide();
                }
                ///console.log("OTP verified and modal closed.");
              });
          })
          .catch((error) => {
            if (error.response && error.response.data) {
              const serverMessage = error.response.data.message;
              console.error("Backend Error:", serverMessage);
              this.errors.otpError = serverMessage || "Something went wrong. Please try again.";
            } else if (error.request) {
              console.error("No response received:", error.request);
              this.errors.otpError = "No response from server. Please check your internet or try again.";
            } else {
              console.error("Request setup error:", error.message);
              this.errors.otpError = error.message || "Something went wrong.";
            }
          })
          .finally(() => {
            this.loading = false;
          });



        
      },


      // startTimer() {
      //   this.stopTimer();

      //   this.countdownInterval = setInterval(() => {
      //     if (this.timer > 0) {
      //       this.timer--;
      //       this.formattedTime = this.formatTime(this.timer);
      //     } else {
      //       this.stopTimer();
      //     }
      //   }, 1000);
      // },
      startTimer() {
        this.stopTimer();

        this.countdownInterval = setInterval(() => {
          if (this.timer > 0) {
            this.timer--;   // ONLY THIS
          } else {
            this.stopTimer();
          }
        }, 1000);
      },
      stopTimer() {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
        this.timerActive = false;
        //this.formattedTime = '';
      },
      // formatTime(seconds) {
      //   const m = Math.floor(seconds / 60).toString().padStart(2, '0');
      //   const s = (seconds % 60).toString().padStart(2, '0');
      //   return `${m}:${s}`;
      // },


      async handleResend() {
        //console.log('this.timerL:', this.timer);
        // if (this.resendDisabled || this.resendCount >= 1) {
        //   this.errors.otpError = 'You’ve exceeded the OTP resend limit.';
        //   return;
        // }
        if (this.timer > 0) {
          this.errors.otpError = 'Please wait before resending the OTP.';
          return;
        }

        this.resendloading = true;
        this.errors.otpError = '';
        const purpose = 'Cancel';

        try {
          const sendOTP = await PurposeSendOtp(this.participant, this.phoneNumber, purpose, this.name, this.email);

          if (sendOTP.data.success === true) {
            this.resendCount++;
            this.timer = 180; 
            this.timerActive = true;
            //this.formattedTime = this.formatTime(this.timer);
            this.startTimer();

            if (this.resendCount >= 1) {
              this.resendDisabled = true;
              setTimeout(() => {
                this.resendCount = 0;
                this.resendDisabled = false;
              }, 5 * 60 * 1000);
              
            }

            this.errors.otpError = '';
          } else {
            this.errors.otpError = sendOTP.data.message || 'Error sending OTP.';
          }
        } catch (error) {
          this.errors.otpError = error?.message || 'Something went wrong.';
        } finally {
          this.resendloading = false;
        }
      },


      async SingleConfirmCancel(bookingId, booking_no, phoneNumber, name, email, applicant_id, applicant_name) {
        const result = await Swal.fire({
          title: 'Are you sure?',
          html: `This action will cancel the appointment for applicant <span style="color: black; font-weight: bold;">${applicant_name}</span> with booking number <span style="color: black; font-weight: bold;">${booking_no}</span>.`,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, cancel it!',
          cancelButtonText: "Don't, Cancel",
          showClass: {
            popup: `animate__animated animate__fadeInUp animate__faster`,
          },
          hideClass: {
            popup: `animate__animated animate__fadeOutDown animate__faster`,
          }
        });

        if (!result.isConfirmed) return;

        const userStore = useUserStore();
        const loggedUser = userStore.user;
        let participant = loggedUser?.user_id;

        if (!participant) {
          const localUser = JSON.parse(localStorage.getItem('userId'));
          participant = localUser?.user_id || null;
        }

        if (!participant) {
          console.error("No user_id found in store or localStorage.");
          this.errors.otpError = "Session expired. Please log in again.";
          return;
        }

        const purpose = 'Cancel';
        this.bookingId = bookingId;
        this.applicant_id = applicant_id;
        this.applicant_name = applicant_name;
        //console.log('this.applicant_id--1:', this.applicant_id);
        ///console.log('applicant_name:', applicant_name);

        Swal.fire({
          title: 'Sending OTP...',
          text: 'Please wait while we send an OTP to your registered mobile number.',
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        this.phoneNumber = phoneNumber;
        this.name = name;
        this.email = email;
        this.participant = participant;

        try {
          const response = await PurposeSendOtp(participant, phoneNumber, purpose, name, email);
          Swal.close();

          if (response.data.success === false) {
            this.errors.otpError = response.data.message || 'Something went wrong.';
            return;
          }

          this.resendCount++;
          this.timer = 180; 
          this.timerActive = true;
          //this.formattedTime = this.formatTime(this.timer);
          this.startTimer();

          if (this.resendCount >= 1) {
            this.resendDisabled = true;
            setTimeout(() => {
              this.resendCount = 0;
              this.resendDisabled = false;
            }, 5 * 60 * 1000);
            
          }

          ///console.log("OTP sent successfully.");
        } catch (error) {
          ///console.error("Axios Error:", error);
          Swal.close();
          this.errors.otpError = "Failed to send OTP. Please try again.";
          return;
        }

        this.$nextTick(() => {
          const modalEl = document.getElementById('SingleotpModal');
          if (modalEl) {
            const otpModal = new bootstrap.Modal(modalEl);
            otpModal.show();
          }
        });
      },

      async SingleResheduleBooking(bookingId, booking_no, phoneNumber, name, email, applicant_id, applicant_name) {
        const result = await Swal.fire({
            title: 'Are you sure?',
            html: `This action will reschedule the appointment for applicant <span style="color: black; font-weight: bold;">${applicant_name}</span> with booking number <span style="color: black; font-weight: bold;">${booking_no}</span>.`,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, reschedule it!',
            cancelButtonText: "Don't, reschedule",
            showClass: {
              popup: `animate__animated animate__fadeInUp animate__faster`,
            },
            hideClass: {
              popup: `animate__animated animate__fadeOutDown animate__faster`,
            }
          });

          if (!result.isConfirmed) return;

          const userStore = useUserStore();
          const loggedUser = userStore.user;
          let participant = loggedUser?.user_id;

          if (!participant) {
            const localUser = JSON.parse(localStorage.getItem('userId'));
            participant = localUser?.user_id || null;
          }

          if (!participant) {
            console.error("No user_id found in store or localStorage.");
            this.errors.otpError = "Session expired. Please log in again.";
            return;
          }

          const purpose = 'Reschedule';
          this.bookingId = bookingId;
          this.applicant_id = applicant_id;
          ///console.log('this.applicant_id--1:', this.applicant_id);
          ///console.log('applicant_name:', applicant_name);

          Swal.fire({
            title: 'Sending OTP...',
            text: 'Please wait while we send an OTP to your registered mobile number.',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });

          this.phoneNumber = phoneNumber;
          this.name = name;
          this.email = email;
          this.participant = participant;

          try {
            const resheduleApplicantData = {
              bookingId,
              booking_no,
              phoneNumber,
              name,
              email,
              applicant_id,
              applicant_name
            };
            localStorage.setItem('resheduleApplicantData', JSON.stringify(resheduleApplicantData));

            const response = await PurposeSendOtp(participant, phoneNumber, purpose, name, email);
            Swal.close();

            if (response.data.success === false) {
              this.errors.otpError = response.data.message || 'Something went wrong.';
              return;
            }

            this.resendCount++;
            this.timer = 180; 
            this.timerActive = true;
            //this.formattedTime = this.formatTime(this.timer);
            this.startTimer();

            if (this.resendCount >= 1) {
              this.resendDisabled = true;
              setTimeout(() => {
                this.resendCount = 0;
                this.resendDisabled = false;
              }, 5 * 60 * 1000);
              
            }

            //console.log("OTP sent successfully.");
          } catch (error) {
            ///console.error("Axios Error:", error);
            Swal.close();
            this.errors.otpError = "Failed to send OTP. Please try again.";
            return;
          }

          this.$nextTick(() => {
            const modalEl = document.getElementById('otpModalSingleReshedule');
            if (modalEl) {
              const otpModal = new bootstrap.Modal(modalEl);
              otpModal.show();
            }
          });
      },

      async validationSingleCancelMain() {
        

        const enteredOtp = this.otpp.join('');
        this.errors.otpError = '';
        if (enteredOtp.length !== 5 || this.otpp.some(digit => digit === '')) {
          this.errors.otpError = "Please enter a valid 5-digit OTP.";
          return;
        }

        this.loading = true;

        const userStore = useUserStore();
        const loggedUser = userStore.user;
        let participant = loggedUser?.user_id;

        if (!participant) {
          const localUser = JSON.parse(localStorage.getItem('userId'));
          participant = localUser?.user_id || null;
        }

        if (!participant) {
          console.error("No user_id found in store or localStorage.");
          this.errors.otpError = "Session expired. Please log in again.";
          return;
        }

        const purpose = 'Cancel';
        
        PurposeVerifyOtp(participant, purpose, enteredOtp)
          .then((response) => {
            const res = response.data;

            if (!res.success || !res.verified) {
              this.errors.otpError = 'OTP is Invalid or Expired.';
              return;
            }
            ///console.log('this.applicant_id:', this.applicant_id);
            // OTP verified, proceed to cancel bookings
            return PurposeCancelSingleBookings(enteredOtp, this.applicant_id)
              .then((cancelResponse) => {
                const cancelRes = cancelResponse.data;
                //console.log("Cancel Response:", cancelRes);
                if (cancelRes.success === true || cancelRes.success === 'true') {
                  Swal.fire({
                    title: `Application Cancelled for ${this.applicant_name}`,
                    text: cancelRes.message || 'Applicant Booking cancelled successfully.',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    showClass: {
                      popup: 'animate__animated animate__fadeInDown',
                    },
                    hideClass: {
                      popup: 'animate__animated animate__fadeOutUp',
                    },
                    customClass: {
                      confirmButton: 'my-red-button',
                    },
                  }).then(() => {
                    window.location.reload();
                  });

                  // setTimeout(() => {
                  //   window.location.reload();
                  // }, 2000);

                } else {
                  this.$toast.error(cancelRes.message || 'Failed to cancel bookings.', {
                    position: 'top-right',
                    duration: 3000,
                  });
                }
              })
              .catch((error) => {
                console.error("CancelAllBookings Error:", error);
                this.$toast.error('Failed to cancel bookings. Please try again.', {
                  position: 'top-right',
                  duration: 3000,
                });
              })
              .finally(() => {
                const modalEl = document.getElementById('SingleotpModal');
                if (modalEl) {
                  const otpModal = bootstrap.Modal.getInstance(modalEl);
                  if (otpModal) otpModal.hide();
                }
                ///console.log("OTP verified and modal closed.");
              });
          })
          .catch((error) => {
            if (error.response && error.response.data) {
              const serverMessage = error.response.data.message;
              ///console.error("Backend Error:", serverMessage);
              this.errors.otpError = serverMessage || "Something went wrong. Please try again.";
            } else if (error.request) {
              ///console.error("No response received:", error.request);
              this.errors.otpError = "No response from server. Please check your internet or try again.";
            } else {
              ///console.error("Request setup error:", error.message);
              this.errors.otpError = error.message || "Something went wrong.";
            }
          })
          .finally(() => {
            this.loading = false;
          });



        
      },

      focusNext2(index, event) {
        if (event.target.value && index < 4) {
          this.$refs.otpInputs1[index + 1].focus();
        }
      },
      focusPrev2(index, event) {
        if (!this.otpp[index] && index > 0) {
          this.$refs.otpInputs1[index - 1].focus();
        }
      },


      // edit here
      async singleEdit(bookingId, booking_no, phoneNumber, name, email, applicant_id, applicant_name) {
          const result = await Swal.fire({
          title: 'Are you sure?',
          html: `This action will Edit the appointment for applicant <span style="color: black; font-weight: bold;">${applicant_name}</span> with booking number <span style="color: black; font-weight: bold;">${booking_no}</span>.`,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, Edit it!',
          cancelButtonText: "Don't, Edit",
          showClass: {
            popup: `animate__animated animate__fadeInUp animate__faster`,
          },
          hideClass: {
            popup: `animate__animated animate__fadeOutDown animate__faster`,
          }
        });

        if (!result.isConfirmed) return;

        const userStore = useUserStore();
        const loggedUser = userStore.user;
        let participant = loggedUser?.user_id;

        if (!participant) {
          const localUser = JSON.parse(localStorage.getItem('userId'));
          participant = localUser?.user_id || null;
        }

        if (!participant) {
          console.error("No user_id found in store or localStorage.");
          this.errors.otpError = "Session expired. Please log in again.";
          return;
        }

        const purpose = 'Edit';
        this.bookingId = bookingId;
        this.applicant_id = applicant_id;
        ///console.log('this.applicant_id--1:', this.applicant_id);
        ///console.log('applicant_name:', applicant_name);

        Swal.fire({
          title: 'Sending OTP...',
          text: 'Please wait while we send an OTP to your registered mobile number.',
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        this.phoneNumber = phoneNumber;
        this.name = name;
        this.email = email;
        this.participant = participant;

        try {
          const response = await PurposeSendOtp(participant, phoneNumber, purpose, name, email);
          Swal.close();

          if (response.data.success === false) {
            this.errors.otpError = response.data.message || 'Something went wrong.';
            return;
          }

          this.resendCount++;
          this.timer = 180; 
          this.timerActive = true;
          //this.formattedTime = this.formatTime(this.timer);
          this.startTimer();

          if (this.resendCount >= 1) {
            this.resendDisabled = true;
            setTimeout(() => {
              this.resendCount = 0;
              this.resendDisabled = false;
            }, 5 * 60 * 1000);
            
          }

          ///console.log("OTP sent successfully.");
        } catch (error) {
          ////console.error("Axios Error:", error);
          Swal.close();
          this.errors.otpError = "Failed to send OTP. Please try again.";
          return;
        }

        this.$nextTick(() => {
          // const modalEl = document.getElementById('otpModalSingleEdit');
          // if (modalEl) {
          //   document.activeElement.blur();
          //   const otpModal = new bootstrap.Modal(modalEl);
          //   otpModal.show();
          // }
          const modalEl = document.getElementById('otpModalSingleEdit');
          if (modalEl) {
            // Fix focus warning
            const active = document.activeElement;
            if (active && modalEl.contains(active)) {
              active.blur();
            }
            // ALWAYS create new instance and SHOW
            const otpModal = new bootstrap.Modal(modalEl);
            otpModal.show();
          }

        });
      },

      async validationEditSingleMain() {
          const enteredOtp = this.otpSingleEdit.join('');
          this.errors.otpError = '';
          if (enteredOtp.length !== 5 || this.otpSingleEdit.some(digit => digit === '')) {
            this.errors.otpError = "Please enter a valid 5-digit OTP.";
            return;
          }

          this.loading = true;

          const userStore = useUserStore();
          const loggedUser = userStore.user;
          let participant = loggedUser?.user_id;

          if (!participant) {
            const localUser = JSON.parse(localStorage.getItem('userId'));
            participant = localUser?.user_id || null;
          }

          if (!participant) {
            console.error("No user_id found in store or localStorage.");
            this.errors.otpError = "Session expired. Please log in again.";
            return;
          }

          const purpose = 'Edit';
          
          PurposeVerifyOtp(participant, purpose, enteredOtp)
            .then((response) => {
              const res = response.data;

              if (!res.success || !res.verified) {
                this.errors.otpError = 'OTP is Invalid or Expired.';
                return;
              }
              //this.entirePageLoading = true;
              ////console.log('this.applicant_id:', this.applicant_id);
              // OTP verified, proceed to cancel bookings
              
              
              const modalEl = document.getElementById('otpModalSingleEdit');
              if (modalEl) {
                const otpModal = bootstrap.Modal.getInstance(modalEl);
                if (otpModal) otpModal.hide();
              }

              //this.showNextComponent = true;
              ///console.log('change view:');
              // this.$emit('change-view', {
              //   view: 'detailsResheduleSingleBooking',
              //   applicant_id: this.applicant_id
              // });

              localStorage.setItem('applicant_id', this.applicant_id);
              const entityId = this.booking.slot.entity_id;
              //console.log('entityId :', entityId);
              ///console.log('this.booking :', this.booking);
              this.entirePageLoading = true;
              GetFormApplicant(entityId)
                .then((response) => {
                  localStorage.removeItem('form_response');
                  localStorage.setItem('form_response', JSON.stringify(response.data)); 
                  return GetApplicantData(this.applicant_id);
                })
                .then((applicant) => {
                  localStorage.setItem('applicant_data', JSON.stringify(applicant.data));
                  this.$emit('change-view', 'detailsSingleEdit');
                })
                .catch((error) => {
                  console.error("Data fetch error:", error);
                  this.errors.otpError = "Failed to load required data. Please try again.";
                })
                .finally(() => {
                  this.entirePageLoading = false;
                });
              
            })
            .catch((error) => {
              if (error.response && error.response.data) {
                const serverMessage = error.response.data.message;
                console.error("Backend Error:", serverMessage);
                this.errors.otpError = serverMessage || "Something went wrong. Please try again.";
              } else if (error.request) {
                console.error("No response received:", error.request);
                this.errors.otpError = "No response from server. Please check your internet or try again.";
              } else {
                console.error("Request setup error:", error.message);
                this.errors.otpError = error.message || "Something went wrong.";
              }
            })
            .finally(() => {
              this.loading = false;
            });
      },

      focusNextEdit(index, event) {
        if (event.target.value && index < 4) {
          this.$refs.otpInputsEdit[index + 1].focus();
        }
      },
      focusPrevEdit(index, event) {
        if (!this.otpSingleEdit[index] && index > 0) {
          this.$refs.otpInputsEdit[index - 1].focus();
        }
      },

      formatKey(key) {
        return key
          .replace(/_/g, ' ')                          
          .replace(/([a-z])([A-Z])/g, '$1 $2')        
          .toLowerCase()
          .replace(/\b\w/g, c => c.toUpperCase());    
      },


      // new member section
      callToAdditionalMember(booking, bookingId, booking_no, phoneNumber, name, email) {
        // set selectedEntity
        this.selectedEntity = {
          id: booking.slot.id,      // or booking.slot.entity_id depending on your data
          title: booking.slot.entity // for display in modal
        };


        const newMembererberApplicantData = {
            bookingId,
            booking_no,
            phoneNumber,
            name,
            email
        };

        // Remove existing item if present
        localStorage.removeItem('newMmberPaymentApplicantData');

        // Set the new item
        localStorage.setItem('newMmberPaymentApplicantData', JSON.stringify(newMembererberApplicantData));

        // show modal
        const modalEl = document.getElementById("applicantModal");
        if (modalEl) {
          const modal = new bootstrap.Modal(modalEl);
          modal.show();
        }
      },

      selectApplicantCount(count) {
        this.selectedApplicantCount = count;
      },
      async showInstructionModal() {
        if (!this.selectedApplicantCount) {
          alert('Please select the number of applicants.');
          return;
        }

        // set instructions dynamically based on selected entity (country)
        //this.selectedInstructions = this.instructionsList[this.booking.slot.entity] || [];
        try {
          const response = await GetSingleEntities(this.booking.slot.entity_id);
          
          this.selectedInstructions = response.data.data.entity_instruction;
          
        } catch (error) {
          console.error('Failed to fetch entities:', error);
        }

        // try to get applicant modal
        let applicantModal = bootstrap.Modal.getInstance(this.$refs.modal);
        if (!applicantModal && this.$refs.modal) {
          applicantModal = new bootstrap.Modal(this.$refs.modal);
        }

        if (applicantModal) {
          // wait until the modal is fully hidden
          this.$refs.modal.addEventListener(
            'hidden.bs.modal',
            () => {
              const instructionModal = new bootstrap.Modal(
                document.getElementById('instructionModal')
              );
              instructionModal.show();
            },
            { once: true }
          );

          applicantModal.hide();
        } else {
          // if no modal is open, just show directly
          const instructionModal = new bootstrap.Modal(
            document.getElementById('instructionModal')
          );
          instructionModal.show();
        }
      },

      toggleInstructions() {
        this.showFullInstructions = !this.showFullInstructions;
      },



      goToNewMember() {
        if (!this.selectedApplicantCount) return;

        const data = {
          booking_id: this.booking.id,
          fullName: this.booking.name,
          email: this.booking.email,
          phone: this.booking.phone,
          country: this.booking.slot.entity_id,
          noOfAdult: this.selectedApplicantCount,
          noOfChildren: this.booking.childs
        };

        ///console.log("The entity data:", data);

        localStorage.removeItem('NewMember_booking_Data');
        localStorage.removeItem('selectedSlot');

        localStorage.setItem("NewMember_booking_Data", JSON.stringify(data));
        localStorage.setItem("selectedSlot", JSON.stringify(this.booking.slot))


        // Use Vue Router to navigate
        this.$router.push({
          name: 'NewMemberPaymentSummary', // route name
          params: { entityId: this.booking.slot.entity_id },
          query: { applicants: this.selectedApplicantCount }
        });

        // optionally close modal
        const modal = bootstrap.Modal.getInstance(this.$refs.modal);
        if (modal) modal.hide();
      },


      isSlotPassed(slot) {
        if (!slot || !slot.start_time || !slot.end_time) return false;
        const now = new Date();
        const slotEnd = new Date(slot.end_time.replace(/\\/g, ''));
        return now > slotEnd;
      },

      safeDateFormat(value, opts) {
        if (!value) return '';
        const date = new Date(value.replace(/\//g, '-'));
        return date.toLocaleString('en-GB', opts);
      },

      resetAllOtpStates() {
        this.otp = ['', '', '', '', ''];
        this.otpp = ['', '', '', '', ''];
        this.otppReshedule = ['', '', '', '', ''];
        this.otpSingleReshedule = ['', '', '', '', ''];
        this.otpSingleEdit = ['', '', '', '', ''];
        this.otpEntireEdit = ['', '', '', '', ''];

        this.errors = {}; // IMPORTANT

        this.stopTimer();
        this.timer = this.otpData.expire_in * 60;

        this.loading = false;
        this.resendloading = false;
      },

    }
  };
  </script>
  